import { SVGProps } from "react";

const SearchNormal = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={22}
    height={22}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.5404 19.25C15.3498 19.25 19.2487 15.3511 19.2487 10.5416C19.2487 5.73217 15.3498 1.83331 10.5404 1.83331C5.73088 1.83331 1.83203 5.73217 1.83203 10.5416C1.83203 15.3511 5.73088 19.25 10.5404 19.25Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.1654 20.1666L18.332 18.3333"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SearchNormal;
